import { useLayoutEffect, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { hideAppLoader, showAppLoader } from '@/shared/runtime/app-loader';
import { useAuth } from '../hooks/useAuth';

export function AuthLoadingController({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const { t } = useTranslation('auth');
  // Login is a guest-page action. Its pending state belongs to the submit
  // button; showing the app-level loader here hides the eventual error.
  const loading = auth.isLoading;

  useLayoutEffect(() => {
    if (loading) {
      showAppLoader(t('session.restoring'));
    } else {
      hideAppLoader();
    }
  }, [loading, t]);

  return children;
}
